<template>
  <ValidationObserver class="needs-validation form-custom-format " v-bind:class="{'was-validated' : validated}" tag="form" ref="observer" v-slot="{passes}" @submit.prevent="onSubmitForm()">
       <ThatsWindow ref="window" title="Collection" windowClass="collection height-auto" scrollClass='collection height-auto' @deleteYes="emitDelete" :width="850" :group="group" :formStatus="FormStatus" @dialog-state="dialogState">
         <template #left-button>
            <template v-if="formLoading">
              <mdb-btn color="elegant" size="sm" disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Loading...
              </mdb-btn>
            </template>
            <template v-else>
              <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)">Save</mdb-btn>
              <!-- <mdb-btn color="elegant" class="ml-0"  size="sm">Save & New</mdb-btn> -->
            </template>
          
            
         </template>
         
         <mdbContainer class="mt-4">
             <mdb-row >

              <mdb-col col="8">
                  <!-- <ThatsSeriesInput labelClass="col-md-3" fieldClass="col-md-4 pl-0" label="Collection ID" placeholder="Collection Code" vid="series" name="series" v-model="form.series" :validated="validated" :rules="'required'" size="sm" :disabled="true" /> -->                  
                  <ThatsInput  labelClass="col-md-3" fieldClass="col-md-9 pl-0" label="Collection Name" vid="name" name="name" v-model="form.name" :validated="validated" :rules="'required'" size="sm" />
                  <ThatsMultiSelect :multiple="false"  labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Brand" v-model="form.brand_id" :reduce="brand => brand.code" :reduceLabel="'brand'" :options="brands" :rules="'required'"></ThatsMultiSelect>
                  <ThatsTextarea labelClass="col-md-3" fieldClass="col-md-9 pl-0" label="Description" ref="descriptionEditor" class="mt-3 mb-3" v-model="form.description">{{form.description}}</ThatsTextarea>

                  <!-- <label @click="uploadImage" class="click-to-add-logo"><mdb-icon icon="paperclip" /> Attach a file</label> -->
                  <ThatsCheckbox :label="'Hidden'" vid="collection-hidden-status" orientation="inline" name="collection-hidden-status" :data="[]" v-model="form.hidden" :validated="validated" :rules="''" size="sm" :multiple="false" />


              </mdb-col>

              <mdb-col col="4 pl-0">
                    <!-- <ThatsImage @open-form="uploadImage" v-model="form.image"></ThatsImage>
                    <label @click="uploadImage" class="click-to-add-logo">Add Image</label> -->

                    <thats-fieldset>
                      <template v-if="form.images.length > 0">
                    <mdb-carousel
                      :items="form.images.length"
                      controlls
                      :controllIcons="['fas fa-arrow-circle-left fa-2x text-white', 'fas fa-arrow-circle-right fa-2x text-white']"
                    >
                     <template #[i+1] v-for="(img, i) in form.images">
                        <mdb-card :key="i">

                          <div class="custom-control image-checkbox custom-checkbox">
                              <input type="checkbox" class="custom-control-input" @change="onSelect($event,img)" :checked="img.default" :id="'imageCheckbox'+img.mdbID" :value="img.path">
                              <label class="custom-control-label image-manager" :for="'imageCheckbox'+img.mdbID" title="Set as default">Set as default</label>
                          </div>

                          <div class="custom-control image-delete" @click="removeImage(i,img.default)">
                              <mdb-icon icon="trash"></mdb-icon>
                          </div>


                          <mdb-card-image
                            :src="img.medium"
                            :alt="img.filename"
                          ></mdb-card-image>
                          
                        </mdb-card>
                      </template>

                    
                    </mdb-carousel>
                      </template>
                      <template v-else>
                        <div class="no-image-gallery">
                          <mdb-icon far icon="images" />
                        </div>
                      </template>
                    <a href="javascript:void(0)" tabindex="17" @click="uploadImage"><mdb-icon icon="image"></mdb-icon> Select Image</a>
                 </thats-fieldset>


                  </mdb-col>


              
             </mdb-row>
         
          
          </mdbContainer>
        
       </ThatsWindow>

      <ImageGrid ref="upload" :moduleForm="'collection-form'" :multiple="true" @select="fnImageSelect" :group="2"></ImageGrid>

  </ValidationObserver>
</template>
<script>
import { mdbBtn,mdbContainer,mdbSelect, mdbRow,mdbCol, mdbIcon,
        mdbCarousel, mdbCard,
    mdbCardImage} from "mdbvue";
import { ValidationObserver } from "vee-validate";
import { mapActions,mapGetters, mapMutations } from 'vuex'
import {ThatsInput, ThatsTextarea, ThatsSeriesInput, ThatsCheckbox,ThatsFieldset, ThatsWindow, ThatsRadio, ThatsMultiSelect, ThatsAutocomplete,ThatsImage} from '../../components/thats/Thats'
import ImageGrid from '../../components/image/ImageGrid'
// import ImageUpload from '../../components/image/ImageUpload'
import { MessageBox } from 'element-ui';
export default {
    components: {
        mdbContainer,
        ValidationObserver,
        ThatsWindow, 
        ThatsInput,  
        ThatsTextarea,  
        ThatsSeriesInput,  
        ThatsCheckbox,  
        ThatsFieldset,
        ThatsRadio,
        ThatsMultiSelect,
        ThatsAutocomplete,
        ThatsImage,
        mdbBtn,
        mdbRow,
        // ImageUpload,
        ImageGrid,
        mdbCol,
        mdbIcon,
        mdbCarousel, mdbCard,
    mdbCardImage  
        
  },
    props : {
      group : {
            type : Number,
            default : 1
        },
      show : {
            type : String,
            default : 'product'
        },
    },
    data : () => ({
      validated : false,
      form : null,
      response : {
        error : null,
        message : null
      },
      formLoading : false,

      area : [],
      brands : [],
      category : [],
    }),

    created : function() {
      if(this.FormStatus == 'create'){
        this.form = this.formVar();
        this.form.show_in = this.show
      } 
      this.optionsHandler()
    },
    methods: {
      ...mapActions('CategoryModule',[ 'GetCategory' ]),
      ...mapActions('AreaModule',[ 'GetArea' ]),
      ...mapActions('BrandModule',[ 'GetBrandErp' ]),
      ...mapActions('CollectionModule',[
        'StoreRecord',
        'UpdateRecord',
        'GetNextCode',
      ]),
      ...mapMutations('CollectionModule',[
        'SetFormStatusCreate',
      ]),

      formVar(){
        return {
          series : 0,
          name : null,
          images : [],
          parent_id : 0,
          parent : null,
          brand_id : null,
          description : null,
          show_in : "product",
          hidden : false,
          attr : {},
          status : 'true'
        }
      },
/* start */
      onSelectBrand(v){
        this.form.category = null
         this.GetCategory({brand : v}).then(response => {
            const category = [];
            response.forEach(element => {
              category.push({category : element.label,code : element.value})
            });
            this.category = category
          });

      },

      optionsHandler(){


        if(this.brands.length <= 0){

          this.GetBrandErp().then(response => {
            const brands = [];
            response.forEach(element => {
              brands.push({brand : element.label,code : element.value})
            });
            this.brands = brands
          });
        }


      },
      
      uploadImage(){
        this.$refs.upload.openDialog();
      },

      nextCode(){
        var self = this;
        this.GetNextCode().then((response) => {
          self.form.series = response.code
        });
      },

      demo(v){
        console.log(v)
      },

/* end */
      openDialog(){
            this.$refs.window.openDialog()
      },
      closeDialog(){
          this.$refs.window.closeDialog()
      },
      fnImageSelect(v){
        if(v.length > 0){
          v.forEach((r,i) => {
            const d = {img : true , mdbID : r.mdbID,token_id : r.token_id,filename : r.filename,path : r.path, default : 0}
            if(i === 0){
              d.default = 1;
            }
              this.form.images.push(d)
          })

        }
      },
      onSubmitForm(){
        var self =this
            this.validated = true
            const isValid = this.$refs.observer.validate();
            if (isValid) {
                // this.form.description = this.getText();
                    if(self.formLoading === false){
                      self.formLoading = true
                      if(self.FormStatus == 'create'){
                          self.StoreRecord(self.form).then((response) => {
                              self.$ThatsNotify.success()
                              self.$emit('success',response)
                              self.closeDialog();
                              self.FormResetter();

                            }).catch((error) => {
                              self.formLoading = false
                              self.response.error = 1;
                              if (error.response) {
                                  if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                  }
                                } else if (error.request) {
                                    self.response.message = error.request
                                } else {
                                    self.response.message = error.message
                                }
                                return;
                            })
                      }

                      if(self.FormStatus == 'update'){
                          self.UpdateRecord(self.form).then((response) => {
                              self.$ThatsNotify.success({
                                message : "Record was successfully updated"
                              })
                                self.closeDialog();
                                self.$emit('success',response)
                                self.FormResetter();
                                

                            }).catch((error) => {
                              self.formLoading = false
                              self.response.error = 1;
                              if (error.response) {
                                  if(error.response.data.hasOwnProperty('errors')){
                                    self.$refs.observer.setErrors(error.response.data.errors);
                                  }
                                } else if (error.request) {
                                    self.response.message = error.request
                                } else {
                                    self.response.message = error.message
                                }
                                return;
                            })
                      }
                    }
                    
            }        
      },

      getText() {
        let text = this.$refs.descriptionEditor.$children;
        text = text.$el.innerHTML;
        return text;
      },
      FormResetter(){
        this.form = this.formVar()
        this.form.show_in = this.show
        requestAnimationFrame(() => {
              this.$refs.observer.reset();
            });
        this.validated = false
        this.formLoading = false
        this.SetFormStatusCreate();
      },
      
      dialogState(state){
        if(!state){
          this.FormResetter();
          return
        }

        if(this.FormStatus == 'create'){
            this.nextCode();
        }

        this.optionsHandler();

      },
      emitDelete(){
        this.$emit('delete',this.FormRecord)
      },

      removeImage(i,isDefault){
  var self = this;
 MessageBox.confirm('This will permanently delete the image?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
                      self.form.images.splice(i,1)
                      
                        
                    })
},

onSelect(e,r){
  console.log(e);
  this.form.images.forEach((img,i) => {
      if(r.token_id === img.token_id){
          this.form.images[i].default = 1
      }else{
        this.form.images[i].default  = 0
      }
  })
  this.form.attr.default_image = parseInt(e.target.value)
},

    },

    computed: {

      ...mapGetters('CollectionModule',
      [
        'FormStatus',
        'FormRecord',
      ]),
    },

    watch: {
      FormRecord : function(){
        if(this.FormStatus == 'update'){
          this.form = JSON.parse(JSON.stringify(this.FormRecord.row));
          if(this.form.attr === null){
              this.form.attr = {}
          }
        }
      },

/*       "form.name" : function(val) {

        if(val !== null){
          const res = val.substring(0, 4)
          this.form.short = res.toUpperCase();
        }
      } */

      /* area : {
        immediate : true,
        handler(){
          this.areaHandle();
        }
        
      } */
    },


}
</script>

<style scoped>
.click-to-add-logo{
  font-size: 14px;cursor: pointer;
}


.custom-control {
    position: absolute!important;
    margin: 10px!important;
}

.custom-control.image-delete{
  right: 0;cursor: pointer;
}

.custom-checkbox .custom-control-label::before {
    border-radius: .50rem!important;cursor: pointer;
}

.no-image-gallery{
  padding: 65px;
  text-align: center;
}

.no-image-gallery i.far {
  font-size: 42px;
  color: #959595;
}
</style>